import { QuestionPlanIsSecret as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-secret";

import { usePlanIsSecret } from "./hooks";

export const QuestionPlanIsSecret = () => {
	const { isSecret, onSetIsSecret, hotelID } = usePlanIsSecret();

	return <Question hotelID={hotelID} isSecret={isSecret} onSetIsSecret={onSetIsSecret} />;
};

QuestionPlanIsSecret.displayName = "QuestionPlanIsSecret";
